import BaseFeature from '../../foundation/base/base';

class SecondaryNavigation extends BaseFeature {
	constructor(element) {
		super(element);

		this.initDomCache();

		this.el = element;
		this.ticking = false;
		this.secondaryNavigation = this.el;
		this.body = window.features.dom.body;
		this.expandHero = this.el.querySelector('[data-js="expandHero"]');
		this.log();
	}
}

export default SecondaryNavigation;
